import React from 'react';
import { Input, Icon } from '@tencent/ten-design-react';
import styles from './PasswordInput.less';

const PasswordInput = (props) => {
  const [isShowText, updateIsShowText] = React.useState(false);
  const [left, setlLeft] = React.useState('0');

  const refElem = React.createRef();
  React.useEffect(() => {
    setTimeout(() => {
      if (refElem.current) {
        setlLeft(`${refElem.current.refInputElem.getBoundingClientRect().width - 40}px`);
      }
    }, 0);
  });

  const onBtnClick = () => {
    updateIsShowText(!isShowText);
  };

  return (
    <div className={styles.container}>
      <Input {...props} type={isShowText ? 'text' : 'password'} ref={refElem} />
      <div className={styles.pwdBtn} style={{ left }} onClick={() => onBtnClick()}>
        {isShowText ? (
          <Icon className={styles.on} type="visibility_on" />
        ) : (
          <Icon className={styles.off} type="visibility_off" />
        )}
      </div>
    </div>
  );
};

export default PasswordInput;
